import styled from "styled-components";
import { Typography } from "@mui/material";
import type { Theme } from "../../constants/themeConstants";

export const ContactAsSectionText = styled(Typography)`
  && {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 36px;
    line-height: 100%;
    letter-spacing: 0%;
    color: ${({ theme }) => (theme as Theme).colors.white};

    margin: 0 0 48px; //0 16px 48px 16px;

    @media (max-width: 768px) {
      margin: 0 0 40px; //0 16px 48px 16px;
    }
  }
`;
